import { useState, useEffect } from 'react'

export interface ThemeToggleProps {
  initialTheme?: 'light' | 'dark'
}

export const useThemeToggle = ({ initialTheme = 'dark' }: ThemeToggleProps) => {
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    return (localStorage.getItem('theme') as 'light' | 'dark') || initialTheme
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'))
  }
  return {
    theme,
    toggleTheme,
  }
}
